import styles from './BannedPage.module.css';

export const BannedPage = () => (
  <div className={styles.page}>
    <div className={styles.card}>
      <div className={styles.icon} aria-hidden>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="m4.9 4.9 14.2 14.2" />
        </svg>
      </div>
      <p className={styles.label}>Доступ ограничен</p>
      <h1 className={styles.title}>Аккаунт заблокирован</h1>
      <p className={styles.text}>
        Тебе недоступны ставки, создание лотов и другие действия в Collector&apos;s Market.
        Если считаешь, что это ошибка — напиши модератору через бота или поддержку проекта.
      </p>
    </div>
  </div>
);
